export default {
  summary: [],
  users: [],
  settings: {
    status: [],
  },
}
